// extracted by mini-css-extract-plugin
var _1 = "TabContent_hidden__cb370";
var _2 = "TabContent_root__d876f";
export { _1 as "hidden", _2 as "root" }
